/* Shared, deterministic bundle arithmetic. Values are integer minor currency units. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SpyBundleRules = factory();
})(typeof window === 'object' ? window : this, function () {
  'use strict';
  function discount(cents, percent) { return Math.round(cents * percent / 100); }
  function eligible(material) { return ['twill', 'leather', 'recycled'].indexOf(material) >= 0; }
  function rate(quantity) { return quantity >= 3 ? 15 : quantity === 2 ? 12 : 0; }
  function validSet(materials) { return materials.every(eligible) ? rate(materials.length) : 0; }
  function priceAfterDiscount(cents, percent) { return cents - discount(cents, percent); }
  function calculate(lines) {
    var original = 0, quantity = 0, savings = 0;
    function valid(line) { return Number.isSafeInteger(line.quantity) && line.quantity > 0 && Number.isSafeInteger(line.unitCents) && line.unitCents >= 0; }
    lines.forEach(function (line) {
      if (!valid(line)) return;
      original += line.unitCents * line.quantity;
      if (eligible(line.material)) quantity += line.quantity;
    });
    var percent = rate(quantity);
    var allocations = lines.map(function (line) {
      var count = percent && valid(line) && eligible(line.material) ? line.quantity : 0;
      var amount = count ? discount(line.unitCents, percent) * count : 0;
      savings += amount;
      return { id: line.id, discountedQuantity: count, discountCents: amount };
    });
    return { eligibleQuantity: quantity, percent: percent, originalCents: original, savingsCents: savings, totalCents: original - savings, allocations: allocations };
  }
  function shipping(subtotal, threshold) { return { qualifies: subtotal >= threshold, remainingCents: Math.max(0, threshold - subtotal) }; }
  return { version: '2026-10-29.1', calculate: calculate, validSet: validSet, priceAfterDiscount: priceAfterDiscount, shipping: shipping };
});
